
define('ldsh!common/templates/loading_view', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-hero pt56 flex align-center justify-center">\r\n  <h2 class="ed-loading">\r\n<!--    <span class="ed-spinner"><span class="ed-icon ed-icon-marquee"></span></span>-->\r\n    <i class="ri-loader-4-fill fa-spin f24"></i>\r\n    <span data-i18n="common.loadingText"></span>\r\n  </h2>\r\n</div>\r\n';

}
return __p
};});

